import { useLocation } from "react-router-dom";

import { Service } from "../../../../types/service.type";

import AboutTab from "./AboutTab";
import VideosTab from "./VideosTab";
import ReviewsTab from "./ReviewsTab";

const PageContentWrapper = ({ programService }: { programService: Service }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");

  if (tab === "videos") return <VideosTab programService={programService} />;
  if (tab === "reviews") return <ReviewsTab programService={programService} />;

  return <AboutTab programService={programService} />;
};

export default PageContentWrapper;
